import AccountConfigRepository from '../../model/AccountConfigRepository'
import EventRepository from '../../model/EventRepository'
import EventListFilter from './EventListFilter.vue'
import EventListItem from './EventListItem.vue'
import Raven from 'raven-js'

export default {
  name: 'EventListView',

  data () {
    return {
      loading: false,

      regions: [],
      filterStatuses: [],
      statuses: [],
      types: [],

    //  loadedEvents: [],
      events: [],
      eventsCount: 0,
      eventBeingDeleted: null,
      deleteConfirmShown: false,
      eventBeingLocked: null,
      lockConfirmShown: false,
      eventBeingUnlocked: null,
      unlockConfirmShown: false,

      paginate: ['events'],
      pagination: {
        'current_page': 1,
        'last_page': 1
      }
    }
  },

  computed: {
    itemCount () {
      return this.eventsCount//events.length
    }
  },

  components: {
    'event-list-filter': EventListFilter,
    'event-list-item': EventListItem
  },

  methods: {
    addEvent() {
      this.$router.push('add-event')
    },


    getFilterParams() {
      let filter = this.$store.state.filter

      filter.types = filter.type
      return filter;
    },

    applyFilter() {
      // let filter = this.$store.state.filter

      if (!this.$store.currentPage) {
        this.$store.currentPage = 1;
      }

      this.loadWithFilter()
      /*
      this.events = this.loadedEvents.filter((event) => {
        let eventStatus
        if (event.isLocked) {
          eventStatus = 'CONFIRMED_AND_LOCKED'
        } else if (event.isConfirmed) {
          eventStatus = 'CONFIRMED'
        } else {
          eventStatus = 'IN_PREPARATION'
        }

        if (
          filter.eventCode && (!event.eventCode || event.eventCode.toLowerCase().indexOf(filter.eventCode.toLowerCase()) === -1)
        ) {
          return false
        }

        if (filter.startDateFrom && event.startDate < filter.startDateFrom) {
          return false
        }

        if (filter.startDateTo && event.startDate > filter.startDateTo) {
          return false
        }

        if (filter.endDateFrom && event.endDate < filter.endDateFrom) {
          return false
        }

        if (filter.endDateTo && event.endDate > filter.endDateTo) {
          return false
        }

        if (filter.regionId && event.regionId !== filter.regionId) {
          return false
        }

        if (filter.status && eventStatus !== filter.status) {
          return false
        }

        return !(filter.type && event.type !== filter.type)
      })

       */
    },

    deleteEvent() {
      let item = this.eventBeingDeleted
      this.loading = true

      return this.eventRepository.deleteEvent(item.id)
        .then(() => {
          //this.$store.currentPage = 1
          this.loadWithFilter()
          /*          this.events = this.events.filter(event => {
                      if (item !== event) {
                        return event
                      }
                    })*/
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    },

    confirmEventDelete(item) {
      this.eventBeingDeleted = item
      this.deleteConfirmShown = true
    },

    confirmEventLock(item) {
      this.eventBeingLocked = item
      this.lockConfirmShown = true
    },

    confirmEventUnlock(item) {
      this.eventBeingUnlocked = item
      this.unlockConfirmShown = true
    },

    copyEvent(event) {
      this.$router.push('copy-event/' + event.id)
    },

    load() {
      this.loading = true
      let promises = []

      this.filterStatuses = [{text: '-- Any --', value: ''}]
        .concat(this.eventRepository.getStatusesForFilter())

      this.statuses = this.eventRepository.getStatuses()

      this.types = [{text: '-- Any --', value: ''}]
        .concat(this.eventRepository.getTypes())

      promises.push(
        this.eventRepository.getStoreRegions()
          .then(regions => {
            this.regions = regions
          })
      )

      return Promise.all(promises)
        .then(() => {
          // this.applyFilter()
          this.loadWithFilter()
          //this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    },

        loadWithFilter() {
          let promises = []
          this.loading = true

          //alert("!" + this.$store.currentPage)

           if (typeof this.$store.currentPage === 'undefined') {
             this.$store.currentPage = 1
           }

         // let currentPage = 1

          //TODO: currentPage - store.getpage.
          //TODO: what to do if event was added - does pages recalc automatically?

          promises.push(
            this.eventRepository.getEventsByPage(this.$store.currentPage, this.getFilterParams())//getAllEvents()//getEventsByPage(1)
              .then(resp => {
                console.log("resp", resp);
               /* this.loadedEvents = */this.events = resp.records
                this.eventsCount = resp.pagination.recordsTotal
                this.pagination.current_page = this.$store.currentPage
                this.pagination.last_page = resp.pagination.lastPage
              })
            /*      TODO: do we need to display "total" records in filter?
                    .then(ret => {
                      this.loadedEvents = this.events = ret.events
                      // this.totlaEventsCount =  ret.total
                    })*/
          )

            return Promise.all(promises)
              .then(() => {
              //  this.applyFilter()
                this.loading = false
              })
              .catch(error => {
                this.loading = false
                this.$reportError(error)
              })
          //}

        },


    editEvent(event) {
    //  alert('bb'+event.speaApiVersion)
      if (event.speaApiVersion) {
        this.$router.push('edit-event/' + event.id)
      }
    },

    lockEvent() {
      this.loading = true
      this.eventRepository.lockEvent(this.eventBeingLocked)
        .then(() => {
          this.eventBeingLocked.isLocked = true
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    },

    multiCopyEvent(event) {
      this.$router.push('copy-event-to-regions/' + event.id)
    },

    unlockEvent() {
      this.loading = true

      let message = ''
      message += 'Account ' + this.$store.state.clientCode
      message += ' event ' + this.eventBeingUnlocked.code
      message += ' unlocked by user ID ' + this.$store.state.userId
      Raven.captureMessage(message, {level: 'info'})

      this.eventRepository.unlockEvent(this.eventBeingUnlocked)
        .then(() => {
          this.eventBeingUnlocked.isLocked = false
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    },

    viewEvent(event) {
      //alert('aa'+event.speaApiVersion)
      if (event.speaApiVersion) {
        this.$router.push('view-event/' + event.id)
      }
    },

    changePage ( ) {
     // alert('test' + this.pagination.current_page);
    //  alert('changePage: '+ this.pagination.current_page)
      this.$store.currentPage = this.pagination.current_page
      this.loadWithFilter()

    },

    goToPage (pageNumber) {
      if (this.$refs.paginator) {
        this.$refs.paginator.goToPage(pageNumber)
      }
    }
  },

  created () {
    this.accountConfigRepository = new AccountConfigRepository(this.$api)
    this.eventRepository = new EventRepository(this.$api)
    this.load()
  }
}



// WEBPACK FOOTER //
// ./src/views/EventList/EventList.js